/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import CookieConsent from "react-cookie-consent";

import { store, persistor } from "store";
import { Header, Footer } from "components";
import {
  Home,
  Job,
  PublishJob,
  About,
  Pricing,
  Login,
  Register,
  PasswordReset,
  Category,
  Contact,
  TermsConditions,
  PrivacyPolicy,
  Payment,
  Admin,
  Resources,
  SearchResults,
  FormBuilder,
  Dashboard,
  FAQ,
} from "pages";
import Config from "config";
import "./App.scss";

localStorage.setItem("isAdmin", Config.isAdmin ? "true" : "false");

const App = () => {
  return (
    <Provider store={store}>
      <CookieConsent
        enableDeclineButton
        buttonStyle={{ background: "white", width: "5rem" }}
        declineButtonStyle={{ width: "5rem", marginRight: "0.5rem" }}
        overlay={false}
        buttonText="Got it!"
        declineButtonText="Decline"
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <div className="appContainer">
            <div className="appContent">
              <Header />
              <Switch>
                <Route exact path="/">
                  <Home />
                </Route>
                <Route path="/job/:id">
                  <Job />
                </Route>
                <Route path="/publish-job">
                  <PublishJob />
                </Route>
                <Route path="/about">
                  <About />
                </Route>
                <Route path="/pricing">
                  <Pricing />
                </Route>
                <Route path="/login">
                  <Login />
                </Route>
                <Route path="/register">
                  <Register />
                </Route>
                <Route path="/reset-password">
                  <PasswordReset />
                </Route>
                <Route path="/category/:id">
                  <Category />
                </Route>
                <Route path="/contact">
                  <Contact />
                </Route>
                <Route path="/terms-conditions">
                  <TermsConditions />
                </Route>
                <Route path="/privacy-policy">
                  <PrivacyPolicy />
                </Route>
                <Route path="/payment">
                  <Payment />
                </Route>
                <Route path="/admin">
                  <Admin />
                </Route>
                <Route path="/dashboard">
                  <Dashboard />
                </Route>
                <Route path="/resources">
                  <Resources />
                </Route>
                <Route path="/search-results">
                  <SearchResults />
                </Route>
                <Route path="/form-builder">
                  <FormBuilder />
                </Route>
                <Route path="/faq">
                  <FAQ />
                </Route>
                <Route component={() => <Redirect to="/" />} />
              </Switch>
            </div>
            <Footer />
          </div>
        </Router>

        {/*
        <div className="screenWarning">

          <p><b>Please use a wider screen or download our mobile app!</b></p>

          <img src={googlePlay} onClick={()=>window.open('https://play.google.com/store/apps/details?id=com.quaxo.remotejobs', '_self')} width="300" />

        </div>
        */}
      </PersistGate>
    </Provider>
  );
};

export default App;
